module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "part1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "PN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "PT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRESH AIR … A LUCKY BREAK")])]), _vm._v(" "), _c('p', {
    staticClass: "PEP"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I knew that I wanted to be someone.… I wanted to be revered by the family … not only by my immediate one, but my extended family as well.… They all were so excited when I finished medical school that they had this large party for me. I still have the pictures. Actually, it spawned many other doctors in the family whose fathers said to them, “Forget about being a wallpaper hanger. If Mickey could do it, then you could do it!”")])]), _vm._v(" "), _c('p', {
    staticClass: "PEPC"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICHAEL")]), _vm._v(" (“M"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("ICKEY")]), _vm._v("”) B"), _c('span', {
    staticClass: "ePub-SC"
  }, [_vm._v("RESCIA")]), _vm._v(", M.D.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51ae99aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 75
// module chunks = 0